document.addEventListener('DOMContentLoaded', () => { 
  const updateCartCount = () => {
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        const countElement = document.querySelector('#custom-cart-icon p');
        if (countElement) {
          countElement.textContent = cart.item_count;
        }
      })
      .catch(err => console.warn('[DEBUG] error al actualizar carrito:', err));
  };

  // Escucha envíos de formularios de add/update
  document.body.addEventListener('submit', (e) => {
    if (e.target.matches('form[action*="/cart/add"], form[action*="/cart/update"]')) {
      setTimeout(updateCartCount, 200);
    }
  });

  // Intercepta fetch
  const origFetch = window.fetch;
  window.fetch = async (...args) => {
    const response = await origFetch(...args);
    const url = args[0];

    if (
      typeof url === 'string' &&
      (url.includes('/cart/add') || url.includes('/cart/change') || url.includes('/cart/update'))
    ) {

      // Actualiza tan pronto la respuesta esté lista
      response.clone().json().then(() => {
        updateCartCount();
      }).catch(() => {
        // fallback por si no es JSON o no tiene body legible
        setTimeout(updateCartCount, 800);
      });

      // fallback adicional por seguridad si Shopify se demora
      setTimeout(updateCartCount, 800);
    }

    return response;
  };

  // Shopify custom events
  ['cart:updated', 'cart:update', 'cart:change'].forEach(evt => {
    document.addEventListener(evt, () => {
      updateCartCount();
    });
  });
});


document.addEventListener('DOMContentLoaded', () => { 
  const updateCartCount = () => {
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        const countElement = document.querySelector('#custom-cart-icon1 p');
        if (countElement) {
          countElement.textContent = cart.item_count;
        }
      })
      .catch(err => console.warn('[DEBUG] error al actualizar carrito:', err));
  };

  // Escucha envíos de formularios de add/update
  document.body.addEventListener('submit', (e) => {
    if (e.target.matches('form[action*="/cart/add"], form[action*="/cart/update"]')) {
      setTimeout(updateCartCount, 200);
    }
  });

  // Intercepta fetch
  const origFetch = window.fetch;
  window.fetch = async (...args) => {
    const response = await origFetch(...args);
    const url = args[0];

    if (
      typeof url === 'string' &&
      (url.includes('/cart/add') || url.includes('/cart/change') || url.includes('/cart/update'))
    ) {

      // Actualiza tan pronto la respuesta esté lista
      response.clone().json().then(() => {
        updateCartCount();
      }).catch(() => {
        // fallback por si no es JSON o no tiene body legible
        setTimeout(updateCartCount, 800);
      });

      // fallback adicional por seguridad si Shopify se demora
      setTimeout(updateCartCount, 800);
    }

    return response;
  };

  // Shopify custom events
  ['cart:updated', 'cart:update', 'cart:change'].forEach(evt => {
    document.addEventListener(evt, () => {
      updateCartCount();
    });
  });
});